import { SproutCommonContent } from "../SproutCommonContent/SproutCommonContent";
import { SproutMedia } from "../SproutMedia/SproutMedia";
import type { IHeroSplitImageProps } from "./HeroSplitImage.props";

export const HeroSplitImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroSplitImageProps) => (
  <div className="sprout-dot-field sprout-hero-art sprout-sky-lift grid min-w-0 overflow-hidden rounded-[2rem] border-2 border-navy-ink md:min-h-[40rem] md:grid-cols-[1.2fr_1fr]">
    <SproutMedia
      aspectRatio={image.aspectRatio || "16:9"}
      className="sprout-paper-lift m-5 min-h-80 min-w-0 rotate-1 rounded-[1.5rem_1.5rem_1.5rem_0.35rem] border-[0.6rem] border-whiteboard md:order-2 md:my-8 md:mr-8 md:ml-0 md:self-center"
      imageClassName="h-full object-cover transition-transform duration-300 ease-out hover:scale-[1.015]"
      media={image.image}
      priority
      sizes="(min-width: 768px) 55vw, 100vw"
    />
    <SproutCommonContent
      alignment={alignment}
      buttons={buttons}
      className="sprout-workbook-paper m-5 min-w-0 justify-center rounded-[1.5rem_1.5rem_1.5rem_0.35rem] border-2 border-navy-ink p-7 md:order-1 md:m-8 md:p-10 lg:p-12"
      description={description}
      eyebrow={eyebrow}
      heading={heading}
      headingAs="h1"
      headingClassName="text-5xl md:text-6xl lg:text-7xl"
    />
  </div>
);

HeroSplitImage.displayName = "Content::HeroSplitImage";
